/**
 * Compares two dotted numeric version strings (e.g. '5.3.0').
 * Returns true when `current` is strictly lower than `target`.
 * Compares segment-by-segment numerically so '5.10.0' is above '5.3.0'.
 */
export function isAppVersionBelow(current: string, target: string): boolean {
  const a = current.split('.').map(Number)
  const b = target.split('.').map(Number)
  const length = Math.max(a.length, b.length)
  for (let i = 0; i < length; i++) {
    const diff = (a[i] ?? 0) - (b[i] ?? 0)
    if (diff !== 0) return diff < 0
  }
  return false
}
